var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NewExpenseUser',{attrs:{"EX":_vm.EX,"warehouses":_vm.warehouses,"countries":_vm.countries,"expenseTypes":_vm.expenseTypes,"banks":_vm.banks,"payees":_vm.payees},on:{"save":_vm.save}})
}
var staticRenderFns = []

export { render, staticRenderFns }